export const AUTH_CONFIG = {
    Auth: {
      region: process.env.REACT_APP_REGION,
  
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
  
      userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_ID,
    },
  
    oauth: {
      domain: process.env.REACT_APP_DOMAIN,
      scope: ['profile', 'email', 'openid'],
      redirectSignIn: process.env.REACT_APP_SERVER,
      redirectSignOut: `${process.env.REACT_APP_SERVER}/auth`,
      clientId: process.env.REACT_APP_CLIENT_ID,
      responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  }